import PaywallFunnelDeployImage from './paywallFunnelDeploy.svg?react';
import { ActionPaywallSource } from '../../../dashboard/paywall/paywallTypes';
import usePaywall from '../../../dashboard/paywall/usePaywall';
import { useRunOnceWhenTruthy } from '../../../common/useRunOnceWhenTruthy';
import { PaywallBlockActionDialog } from '../../../dashboard/paywall/PaywallBlockActionDialog';

const CanvasDeployPaywallBlock = ({ closeDialog }: { closeDialog: () => void }) => {
  const { isPaywallActive, sendEncounterPaywallEvent } = usePaywall();

  useRunOnceWhenTruthy(() => {
    sendEncounterPaywallEvent({
      source: ActionPaywallSource.FUNNEL_DEPLOY,
    });
  }, isPaywallActive);

  if (!isPaywallActive) {
    return null;
  }

  return (
    <PaywallBlockActionDialog
      infoText="With Sweep, you can deploy end-to-end business processes to any Salesforce
                environment in a click. Talk to a Sweep team member to activate your free trial."
      title="Ready to deploy directly to Salesforce?"
      Image={<PaywallFunnelDeployImage />}
      closeDialog={closeDialog}
      source={ActionPaywallSource.FUNNEL_DEPLOY}
    />
  );
};

export default CanvasDeployPaywallBlock;
